import {ViewerGuideType} from '../../../../../../design-system/organisms/ViewerGuide/ViewerGuideType.enum';
import {ViewerType} from '../constant/viewerConstant';
import {ImageViewerReadType} from '../type/ImageViewerReadType';
import {TextViewerReadType} from '../type/TextViewerReadType';
import {ViewingMode} from '../type/ViewingMode.enum';

export function convertViewerReadTypeToGuideType({
  viewerType,
  viewerReadType,
  isReverseViewDirection,
}: {
  viewerType: ViewerType;
  viewerReadType: TextViewerReadType | ImageViewerReadType | ViewingMode;
  isReverseViewDirection?: boolean;
}): ViewerGuideType {
  switch (viewerType) {
    case ViewerType.TextViewer:
      return viewerReadType === TextViewerReadType.Page
        ? ViewerGuideType.Forward
        : ViewerGuideType.Scroll;
    case ViewerType.ImageViewer:
      return viewerReadType === ImageViewerReadType.Page
        ? isReverseViewDirection // 열람 방식이 역방향이면 가이드를 역방향으로 (이미지 뷰어만 존재)
          ? ViewerGuideType.Reverse
          : ViewerGuideType.Forward
        : ViewerGuideType.Scroll;
    case ViewerType.TalkViewer:
      return viewerReadType === ViewingMode.Tap
        ? ViewerGuideType.Tap
        : ViewerGuideType.Scroll;
    default:
      return ViewerGuideType.Forward;
  }
}
